import ShippingAddressDTO from "@/dto/ShippingAddressDTO";
import { getList } from "@/services/api/setting/shippingAddress";
import { buildShippingAddressInfo } from "@/utils/OrderUtils";
import { QuestionCircleFilled } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { Select, Tooltip } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "./SectionTitle";

interface ShippingAddressSelectProps {
    onLoad?: () => void;
}

export interface ShippingAddressSelectInstance {
    shipperAddressId: number;

    reset();

    setShipperAddressId: React.Dispatch<React.SetStateAction<number>>;

    shippingAddresses: ShippingAddressDTO[];
}

const ShippingAddressSelect: React.ForwardRefRenderFunction<ShippingAddressSelectInstance, ShippingAddressSelectProps> =
    function (props, ref) {
        const { runAsync, loading, data: shippingAddresses } = useRequest(getList);

        const [shipperAddressId, setShipperAddressId] = useState<number>();

        async function handleFocus() {
            if (shippingAddresses) return;

            runAsync();
        }

        function handleChange(id) {
            setShipperAddressId(id);
        }

        function handleClear() {
            setShipperAddressId(null);
        }

        React.useImperativeHandle(ref, () => ({
            shipperAddressId,
            reset: handleClear,
            setShipperAddressId,
            shippingAddresses,
        }));

        return (
            <>
                <SectionTitle
                    title="发货人信息"
                    extra={
                        <>
                            （非必填可不选，常用于快递网点代打面单场景
                            <Tooltip
                                title={
                                    <span>
                                        常用于快递网点代打面单场景：该发货人仅用于标记是帮谁代打，
                                        <a
                                            href="https://qw15p3s8hv.feishu.cn/wiki/QdKbwsgVoihHvNkKZoNcLPOMn4b"
                                            target="_blank"
                                        >
                                            点击可查看详细说明
                                        </a>
                                    </span>
                                }
                            >
                                <QuestionCircleFilled className="ml5 mr5" style={{ color: "#337ab7" }} />
                            </Tooltip>
                            ，可<Link to="/setting/shippingAddress/add">点击这里</Link>
                            添加发货人）
                        </>
                    }
                />

                <Select
                    loading={loading}
                    onFocus={handleFocus}
                    allowClear
                    onChange={handleChange}
                    value={shipperAddressId}
                    onClear={handleClear}
                    className="w mb10"
                    showSearch={{
                        optionFilterProp: "label",
                        filterOption: true,
                    }}
                    placeholder="可输入发货人信息快速搜索"
                    data-openreplay-masked
                    options={[
                        ...(shippingAddresses?.map((shippingAddress) => {
                            return {
                                key: shippingAddress.id,
                                value: shippingAddress.id,
                                "data-openreplay-masked": true,
                                label: buildShippingAddressInfo(shippingAddress),
                            };
                        }) ?? []),
                    ]}
                />

            </>
        );
    };

export default React.memo(React.forwardRef(ShippingAddressSelect));
